import simpleRestProvider from 'ra-data-simple-rest';

import { api } from './config';
import { httpClient } from './auth';

const dataProvider = simpleRestProvider(api.url, httpClient);

export default dataProvider;
